import React from 'react';
import { cn } from '@/utils/cn';
import { Spinner } from '@/components/UI/Spinner';

export interface LoadingStateProps {
  label?: React.ReactNode;
  className?: string;
}

/** Centered spinner + label for a list or panel that is still loading. */
export const LoadingState: React.FC<LoadingStateProps> = ({ label = 'Loading…', className }) => (
  <div role="status" className={cn('flex flex-col items-center justify-center gap-2 px-4 py-16 text-center', className)}>
    <Spinner size="sm" />
    <p className="text-sm text-ui-text3">{label}</p>
  </div>
);

export default LoadingState;
